module.exports = __webpack_public_path__ + "static/media/Thumbs.02f4376a.db";